import { create } from 'zustand';
import axiosClient from '../../src/services/api';

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  error: null,

  fetchNotifications: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const res = await axiosClient.get('/notifications', { params });
      set({ 
        notifications: res.data.notifications,
        unreadCount: res.data.notifications.filter(n => !n.isRead).length,
        isLoading: false 
      });
    } catch (error) {
      set({ 
        error: error.response?.data?.error || 'Failed to fetch notifications',
        isLoading: false 
      });
    }
  },

  markAsRead: async (id) => {
    try {
      await axiosClient.put(`/notifications/${id}/read`);
      set(state => ({
        notifications: state.notifications.map(n => 
          n._id === id ? { ...n, isRead: true } : n
        ),
        unreadCount: state.unreadCount > 0 ? state.unreadCount - 1 : 0
      }));
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
    }
  },

  markAllAsRead: async () => {
    try {
      await axiosClient.put('/notifications/read-all');
      set(state => ({
        notifications: state.notifications.map(n => ({ ...n, isRead: true })),
        unreadCount: 0
      }));
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
    }
  },

  handleNewNotification: (notification) => {
    set(state => ({
      notifications: [notification, ...state.notifications],
      unreadCount: state.unreadCount + 1
    }));
  }
}));

export default useNotificationStore;